import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'
import { Box, Typography, IconButton } from '@mui/material'

interface DetailedViewHeaderProps {
  onClose: () => void
  title?: string
}

const headerContainerStyles = {
  display: 'flex',
  alignItems: 'center',
  p: 2,
  borderBottom: '1px solid #EAE9E9',
  backgroundColor: '#fff',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
  position: 'sticky' as const,
  top: 0,
}

const backButtonStyles = {
  mr: 1,
}

const titleStyles = {
  fontSize: '18px',
  fontWeight: 600,
  color: '#333',
}

export const DetailedViewHeader = ({ onClose, title = 'Details' }: DetailedViewHeaderProps) => {
  return (
    <Box sx={headerContainerStyles}>
      <IconButton onClick={onClose} sx={backButtonStyles}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant='h6' sx={titleStyles}>
        {title}
      </Typography>
    </Box>
  )
}
